import { Component, Input } from '@angular/core';
import { NavOverFlowWrapperAction } from '../../enums/nav-overflow-wrapper-action.enum';
import { ContentUtil } from '../../utils/content/content.util';

import { NavOverflowExtendedData } from '../../interfaces/nav-overflow-extended-data.interface';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ActionNavOverflowMenuComponent } from '../action-nav-overflow-menu/action-nav-overflow-menu.component';

export interface ActionNavOverflowMenuWrapperComponentProps {
    navOverflowExtendedData: NavOverflowExtendedData;
    navAction: NavOverFlowWrapperAction;
}

@Component({
    selector: 'zci-action-menu-wrapper',
    templateUrl: './action-menu-wrapper.component.html',
    imports: [
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        ActionNavOverflowMenuComponent,
    ],

})
export class ActionMenuWrapperComponent implements ActionNavOverflowMenuWrapperComponentProps {
    @Input() navOverflowExtendedData: NavOverflowExtendedData;

    @Input() navAction: NavOverFlowWrapperAction;

    NavOverFlowWrapperAction = NavOverFlowWrapperAction;

    content = ContentUtil.content;
}
